var widget_default = {
  "card": "we33V",
  "link": "EGa6F",
  "container": "JECAd",
  "image": "bZK-N",
  "right": "ydsIQ",
  "cardLayout": "_4fr0N",
  "content": "_6ReeG",
  "title": "_43iHz",
  "subtitle": "IYwbJ",
  "button": "E4muo",
  "button_disabled": "_066Nd",
  "buttonText": "WjEUZ",
  "slimLayout": "_5xnh8",
  "contentText": "_6mFMA"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
